export default "__VITE_ASSET__BRW$RyfY__"